import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { InvoiceMissionOptions } from '../models/options/invoiceMissionOptions';
import { InvoiceMissionResponse } from '../models/invoiceMission/invoiceMission';
import { InvoiceSendingTypeStringEnum } from '../models/enums/InvoiceSendingTypeString.enum';

const controller = 'InvoiceMission';

const getAll = (opts: InvoiceMissionOptions) => {
  return AxiosInstance.get<PagedResult<InvoiceMissionResponse>>(`${controller}`, {
    params: opts,
  });
};

const getById = (id: string | number, sendingType?: number, includeSendingApprovalEmails?: boolean) => {
  let endpoint = sendingType !== undefined && sendingType > 0 ? `${controller}/${id}/${sendingType}` : `${controller}/${id}`;
  endpoint += includeSendingApprovalEmails ? `?includeSendingApprovalEmails=${includeSendingApprovalEmails}` : '';
  return AxiosInstance.get<InvoiceMissionResponse>(endpoint);
};

const deleteInvoiceMission = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};

export const acceptInvoiceMission = (invoiceMissionId: number, sendingType: InvoiceSendingTypeStringEnum | null) => {
  const endpoint = `${controller}/${invoiceMissionId}/Accept/${sendingType}`;
  return AxiosInstance.put(endpoint);
};

export const rejectInvoiceMission = (invoiceMissionId: number, sendingType: InvoiceSendingTypeStringEnum | null, message: string) => {
  const endpoint = `${controller}/${invoiceMissionId}/Reject/${sendingType}`;
  return AxiosInstance.put(endpoint, { message });
};

const autogiroController = 'MemberAutogiro';

export const createAutogiroFile = (missionId: number) => {
  return AxiosInstance.put(`${autogiroController}/CreateFile?missionId=${missionId}`, null, { timeout: 180000 });
};

export const sendAutogiroFile = (missionId: number) => {
  return AxiosInstance.put(`${autogiroController}/SendFile?missionId=${missionId}`, null, { timeout: 180000 });
};

// Ångrar en autogirokörning: raderar avier/uppdrag/fil och återställer autogirostatus.
// skipErrorToast: felet hanteras med egen toast i komponenten (undviker dubbla toaster).
export const undoCreateAutogiroInvoices = (missionId: number) => {
  return AxiosInstance.put(`${autogiroController}/UndoCreateInvoices?missionId=${missionId}`, null, {
    timeout: 180000,
    skipErrorToast: true,
  });
};

// Talar om ifall autogirofilen finns och redan skickats till Bankgirot (för varning innan man ångrar).
// skipErrorToast: bakgrundsuppslag – ett saknat/felande svar ska inte störa användaren med en toast.
export const getAutogiroFileStatus = (missionId: number) => {
  return AxiosInstance.get<{ hasFile: boolean; sent: boolean }>(`${autogiroController}/FileStatus?missionId=${missionId}`, {
    skipErrorToast: true,
  });
};

export const createInvoiceMissionRefund = (missionId: number, data: { dueDate: string; rows: Array<{ invoiceId: number; amount: number }> }) => {
  // eslint-disable-next-line camelcase
  return AxiosInstance.post<{ invoiceMission_id: number; rowsCreated: number }>(`${controller}/${missionId}/CreateRefund`, data, { timeout: 180000 });
};

export type InvoiceRefundRow = {
  invoiceId: number;
  customerId: number | null;
  customerName: string;
  amount: number;
};

export const getRefundableInvoices = (missionId: number) => {
  return AxiosInstance.get<InvoiceRefundRow[]>(`${controller}/${missionId}/RefundableInvoices`);
};

export default {
  getAll,
  getById,
  deleteInvoiceMission,
};
